import { useMutation, useQuery } from "@tanstack/react-query";

import { api } from "./ApiClient";

import { CookiesHelper } from "../helpers/cookies.helper";

import { ICompleteDataFilters } from "../types/misc.interface";
import { ISessionsForCD, HMILoginRequest, ILoginResponse } from "../types/services.interface";

export const useCreateSession = () => {
    const mutationFn = async (): Promise<string> => {
        const token = CookiesHelper.get(`${process.env.REACT_APP__SESSION_TOKEN_NAME}`);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.post('/sessions');
        return res.data;
    };

    return useMutation({
        mutationFn,
        onSuccess: (token) => {
            CookiesHelper.set(`${process.env.REACT_APP__SESSION_TOKEN_NAME}`, token, (4 * 24 * 60 * 60 * 1000));
        },
    });
};

export const useLogin = () => {
    const mutationFn = async (data: HMILoginRequest): Promise<ILoginResponse> => {
        const res = await api.post('/sessions/login', data.payload);
        return res.data;
    };

    return useMutation({
        mutationFn,
        onMutate: (variables) => {
            variables.setIsLoading(true);
        },
        onSuccess: (data) => {
            CookiesHelper.set(`${process.env.REACT_APP__AUTH_TOKEN_NAME}`, data.auth_token, (24 * 60 * 60 * 1000));
            CookiesHelper.set(`${process.env.REACT_APP__SESSION_TOKEN_NAME}`, data.session_token, (4 * 24 * 60 * 60 * 1000));
        },
        onError: (error: any, variables) => {
            variables.setError(error?.response?.data?.message || 'Something went wrong.');
        },
        onSettled: (_, __, variables) => {
            variables.setIsLoading(false);
        },
    });
};

export const useGetSessionsForCD = (filters: ICompleteDataFilters) => {
    const queryFn = async (): Promise<ISessionsForCD> => {
        const finalFilters = {
            start_date: filters.start_date?.length ? filters.start_date : undefined,
            end_date: filters.end_date?.length ? filters.end_date : undefined,
            scores: filters.scores?.length ? filters.scores : undefined,
            simulation_keys: filters.simulation_keys?.length ? filters.simulation_keys : undefined,
        };
        const res = await api.get(`/sessions/complete-data/list`, { params: finalFilters });
        return res.data;
    };

    return useQuery({
        queryKey: ['sessions-for-complete-data', filters],
        queryFn,
        retry: false,
    });
};